import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import {
	LANGUAGE_CHANGED_EVENT,
	LANGUAGE_STORAGE_KEY,
	SUPPORTED_LANGUAGES,
	normalizeLanguage,
} from '@ms/shared/i18n/language'
import 'animate.css'
import './style/auth_header_actions.css'

function AuthHeaderActions({ className = '' }) {
	const { t, i18n } = useTranslation()
	const currentLanguage = normalizeLanguage(i18n.resolvedLanguage || i18n.language)
	const languageOptions = SUPPORTED_LANGUAGES.map((language) => ({
		...language,
		label: t(`header.languages.${language.code}`),
	}))

	const changeLanguage = (language) => {
		const nextLanguage = normalizeLanguage(language)

		i18n.changeLanguage(nextLanguage)
		localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage)
		window.dispatchEvent(new CustomEvent(LANGUAGE_CHANGED_EVENT, { detail: nextLanguage }))
	}

	const showContactUs = () => {
		Swal.fire({
			title: '',
			text: t('header.contactDetails'),
			customClass: { htmlContainer: 'auth-contact-popup__message' },
			showClass: { popup: 'animate__animated animate__zoomIn animate__faster' },
			hideClass: { popup: 'animate__animated animate__zoomOut animate__faster' },
			confirmButtonColor: '#28825A',
		})
	}

	const selectedLanguageTemplate = () => (
		<span className='auth-header-actions__language-value'>
			<i className='pi pi-globe' aria-hidden='true' />
			<span>{t('header.changeLanguage')}</span>
		</span>
	)

	const languageOptionTemplate = (option) => (
		<span className='auth-header-actions__language-option'>
			<strong>{option.shortLabel}</strong>
			<span>{option.label}</span>
			<small>{option.nativeLabel}</small>
		</span>
	)

	return (
		<div className={`auth-header-actions ${className}`.trim()}>
			<Dropdown
				value={currentLanguage}
				options={languageOptions}
				optionLabel='label'
				optionValue='code'
				onChange={(event) => changeLanguage(event.value)}
				valueTemplate={selectedLanguageTemplate}
				itemTemplate={languageOptionTemplate}
				className='auth-header-actions__language'
				panelClassName='auth-header-actions__language-panel'
				ariaLabel={t('header.changeLanguage')}
				title={t('header.changeLanguage')}
			/>
			<button
				type='button'
				className='auth-header-actions__contact'
				onClick={showContactUs}
				aria-label={t('header.contactUs')}
				title={t('header.contactUs')}
			>
				<i className='pi pi-headphones' aria-hidden='true' />
				<span>{t('header.contactUs')}</span>
			</button>
		</div>
	)
}

export default AuthHeaderActions
